import { Dialog, Transition } from "@headlessui/react";
import React, { FC, Fragment, useEffect, useState, useMemo, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import Select from 'react-select';
import ButtonClose from "shared/ButtonClose/ButtonClose";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import axios from "axios";
import withRouter from "components/Common/withRouter";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import { useFormik } from "formik";
import { RootState } from 'store/reducers';
import { isImageJpgOrPng, isImageSizeValid, callMultipartFormDataApi, isSheet, isImageJpgOrPngOrPdf, presignedUrl, uploadFileToS3 } from "components/Common/commonFunction";
import { useDispatch, useSelector } from "react-redux";
import Loader from "containers/Admin/Loader";
import {
    clearData,
    getList as onGetList,
    getData as onGetData,
    updateData as onUpdateData,
    addNewData as onAddNewData,
} from "store/AppMaster/actions";
import api from "constants/api";
import {
    Typography,
    Button,
    Avatar,
} from "@material-tailwind/react";


import noImageFound from '../../../images/No_Image_Available.jpg'
export interface EditProps {
    show: boolean;
    onCloseModalQuickView: () => void;
    optionCategory: any[];
}

const Edit: FC<EditProps> = (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const initialRender = useRef(true);
    const location = useLocation();
    const dispatch = useDispatch();
    const [isApiCall, setIsApiCall] = useState(0)
    const [optionListData, setOptionListData] = useState(false);
    const [groupData, setGroupData] = useState<Boolean>(false);
    const [optionCategory, setOptionCategory] = useState<any[]>([]);
    const [selectedData, setSelectedData] = useState([]);
    const [loderImage, setLoader] = useState(false);
    const [fontList, setFontList] = useState<string[]>([]);

    const [frmData, setFrmData] = useState({
        id: "",
        hyperlink: "",
        content: "",
        status: "",
        colour_code: "#000000",
        font_style: "",
    });

    const onChangeHandler = (event: any) => {
        const { name, value } = event.target;
        setFrmData((preValue) => {
            return {
                ...preValue,
                [name]: value,
            };
        });
    }

    const statusOptions = [
        { key: 'Active', value: 'Active' },
        { key: 'Inactive', value: 'Inactive' },
    ];

    useEffect(() => {
        if (isApiCall === 0) {
            getGroupDetails();
            setIsApiCall(1);
        }
        initialRender.current = false;

        if (groupData == true && optionCategory.length === 0) {
            setOptionListData(true);
        }
    }, [isApiCall, groupData, optionCategory]);

    useEffect(() => {
        const fetchFonts = async () => {
            const apiKey = process.env.REACT_APP_GOOGLE_FONTS_API_KEY || "AIzaSyBwxglAR8bqGmldyXzHwPytQFdbj15xWD4";
            if (!apiKey) {
                console.warn("Google Fonts API Key is missing.");
                return;
            }
            try {
                const response = await axios.get(
                    `https://www.googleapis.com/webfonts/v1/webfonts?key=${apiKey}`
                );
                if (response.data && response.data.items) {
                    // Take top 50 popular fonts
                    const fonts = response.data.items.map((item: any) => item.family);
                    setFontList(fonts);
                }
            } catch (error) {
                console.error("Error fetching Google Fonts:", error);
            }
        };
        fetchFonts();
    }, []);

    const { data } = useSelector((state: RootState) => state.AppMaster);


    const getGroupDetails = () => {
        setGroupData(true);
        //dispatch(clearData())
        let filterData = {
            id: params.id
        }
        dispatch(onGetData(filterData, '', api.getSpecialMessageDetail));
    }


    if (data != null && groupData == true) {
        if (data.result != null) {
            setGroupData(false);
            console.log(data.result, "divy");

            setFrmData((preValue) => {
                return {
                    ...preValue,
                    id: data.result._id,
                    hyperlink: data.result.hyperlink,
                    content: data.result.content,
                    status: data.result.status,
                    colour_code: data.result.colour_code || "#000000",
                    font_style: data.result.font_style || "",
                };
            });
        }
    }
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed


        enableReinitialize: true,
        initialValues: {
            id: frmData.id,
            hyperlink: frmData.hyperlink,
            content: frmData.content,
            status: frmData.status,
            colour_code: frmData.colour_code,
            font_style: frmData.font_style,
        },
        validationSchema: Yup.object({
            hyperlink: Yup.string(),
            content: Yup.string().required("Content is required"),
            status: Yup.string().required("Status is required"),
            colour_code: Yup.string().required("Color is required"),
            font_style: Yup.string().required("Font is required"),
        }),
        onSubmit: async (values) => {
            const newData = {
                id: frmData.id,
                hyperlink: values.hyperlink,
                content: values.content,
                status: values.status,
                colour_code: values.colour_code,
                font_style: values.font_style,
            };
            dispatch(onUpdateData(newData, '', api.updateSpecialMessage));
            // setSubmitted(true);
            setTimeout(() => {
                navigate('/admin/special-message');
            }, 1500);
        },
    });


    return (
        <div className="container py-16 lg:pb-28 lg:pt-20">
            <Helmet>
                <title>Edit Special Message</title>
            </Helmet>
            <Loader
                loderImage={loderImage}
            />
            <div className="mb-12 sm:mb-16">
                <h2 className="block text-2xl sm:text-3xl lg:text-4xl font-semibold ">Edit Special Message</h2>
            </div>
            <div className="mt-8 sm:mt-10">
                <div className="flex-1  rounded-xl hiddenScrollbar">
                    <form
                        onSubmit={e => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                        method="post">
                        <div className="p-4">
                            <div className="mb-4">
                                <label
                                    htmlFor="title"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Enter the Content of Special Message
                                </label>
                                <input
                                    id="content"
                                    name="content"
                                    placeholder="Content"
                                    type="text"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    value={frmData.content}
                                    onChange={onChangeHandler}
                                />
                                {validation.errors.content ? (
                                    <div className="text-red-500 text-sm mt-1">
                                        {validation.errors.content}
                                    </div>
                                ) : null}
                            </div>
                            <div className="mb-4">
                                <label
                                    htmlFor="content"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Enter the Link of Special Message
                                </label>
                                <input
                                    id="hyperlink"
                                    name="hyperlink"
                                    value={frmData.hyperlink}
                                    placeholder="Link"
                                    type="text"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    onChange={onChangeHandler}
                                />
                                {validation.errors.hyperlink ? (
                                    <div className="text-red-500 text-sm mt-1">
                                        {validation.errors.hyperlink}
                                    </div>
                                ) : null}
                            </div>
                            <div className="mb-4">
                                <label
                                    htmlFor="colour_code"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Select Text Color
                                </label>
                                <div className="flex items-center gap-3 mt-1">
                                    <input
                                        id="colour_code"
                                        type="color"
                                        className="h-10 w-20 border border-gray-300 rounded-md cursor-pointer"
                                        name="colour_code"
                                        value={validation.values.colour_code}
                                        onChange={validation.handleChange}
                                    />
                                    <input
                                        type="text"
                                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                        value={validation.values.colour_code}
                                        onChange={(e) => validation.setFieldValue('colour_code', e.target.value)}
                                        placeholder="#000000"
                                    />
                                </div>
                                {validation.errors.colour_code ? (
                                    <div className="text-red-500 text-sm mt-1">
                                        {validation.errors.colour_code}
                                    </div>
                                ) : null}
                            </div>
                            <div className="mb-4">
                                <label
                                    htmlFor="font_style"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Select Font Style
                                </label>
                                <select
                                    id="font_style"
                                    name="font_style"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    value={validation.values.font_style}
                                    onChange={validation.handleChange}
                                >
                                    <option value="">Select Font Style</option>
                                    {fontList.length > 0 ? (
                                        fontList.map((font) => (
                                            <option key={font} value={font} style={{ fontFamily: font }}>
                                                {font}
                                            </option>
                                        ))
                                    ) : (
                                        <>
                                            <option value="Roboto">Roboto (Default)</option>
                                            <option disabled>Loading or No API Key...</option>
                                        </>
                                    )}
                                </select>
                                {validation.errors.font_style ? (
                                    <div className="text-red-500 text-sm mt-1">
                                        {validation.errors.font_style}
                                    </div>
                                ) : null}
                            </div>

                            <div className="mb-4">
                                <label
                                    htmlFor="status"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Select Status
                                </label>
                                <select
                                    id="status"
                                    name="status"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    value={frmData.status}
                                    onChange={onChangeHandler}
                                >
                                    <option value="">Select Status</option>
                                    {statusOptions.map(option => (
                                        <option key={option.key} value={option.key}>
                                            {option.value}
                                        </option>
                                    ))}
                                </select>
                                {validation.errors.status ? (
                                    <div className="text-red-500 text-sm mt-1">
                                        {validation.errors.status}
                                    </div>
                                ) : null}
                            </div>

                            <div className="text-center mt-3">
                                <ButtonPrimary type="submit">
                                    <span>Submit</span>
                                </ButtonPrimary>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default withRouter(Edit);
